<template>
  <div class="main">
    <div class="warning-tips-box">
      <div class="title">
       <span class="infoicon"></span>温馨提示
      </div>
      <div class="result">
        <div>·文件生成完成后，需手动刷新确认完成后才能下载</div>
        <div>·导出任务保留最近3天时间(包含当天)，超过3天的导出记录自动删除</div>
      </div>
    </div>

    <ul>
      <template 	v-for="(item,i) in taskTask" >
      <li class="item">
        <div>
          <div class="time" v-if="item.createTime.split(' ')[0]!=(i-1<0?'':(taskTask[i-1].createTime.split(' ')[0]))">
            <template v-if="item.createTime.split(' ')[0]==new Date().toJSON().split('T')[0]">今天</template>
            <template v-else>{{item.createTime.split(' ')[0]}}</template>

          </div>
          <div class="item-block">
            <div>
              <div>
                <img src="../assets/img/excel.png" alt srcset   />
              </div>
              <div style="cursor:pointer" >
                   <a :href="item.downloadUrl" style="text-decoration:none;color:#4c83e3">下载</a>
                </div>
            </div>
            <div>
              <div style="font-size:13px;font-weight:bold">{{item.fileName}}&nbsp;&nbsp;{{item.createTime}}</div>
              <div style="cursor:pointer;min-height:25px;">
				    <a :href="item.downloadUrl" style="text-decoration:none;color:black;">  {{item.downloadUrl}}</a>
				</div>
              <div v-if="item.process==2" style="color:grey">任务已完成</div>
              <div v-if="item.process==1" >任务进行中</div>
            </div>
            <!-- <div class="close" @click="close(item.versionId)">
              <i class="el-icon-close"></i>
            </div> -->
          </div>
        </div>
      </li>
      </template>
    </ul>
  </div>
</template>
<script>
import store from '../store/index.js'
import axios from 'axios'
import {getAllExportList} from '../config/interface.js'
import {toast} from '../util/tool.js'
import {fetch} from '../config/fetch.js'
export default {
	data() {
		return {
			taskTask: null,
		};
	},
	created() {
    this.init();
	},
	methods: {
		download() {},
		init() {
			let params = {
        appId: this.$store.state.appId,
        userId: this.$store.state.userId,
        bodyId: this.$store.state.bodyId
      };
			fetch(getAllExportList, params).then(res => {
				this.taskTask = res.data.result;
			});
		},
		close(id) {
			let params = {
				versionId: id,
			};
			let that = this;
			fetch(deleteExportTask, params).then(res => {
				bs.toast('删除成功', 'success', false, function() {
					that.init();
				});
			});
		},
	},
};
</script>
<style scoped>
.item {
  margin-top: 20px;
  list-style-type: none;
}
.item .close {
  cursor: pointer;
  position: absolute;
  width: 15px;
  height: 15px;
  top: 20px;
  right: 20px;
}
.item .time {
  font-size: 20px;
  font-weight: bold;
}
.item .item-block {
  position: relative;
  display: flex;
  flex-direction: row;
  padding: 0 15px;
  margin-top: 20px;
  background: white;
  box-shadow: 0px 3px 6px rgba(158, 165, 162, 0.2);
  opacity: 1;
  border-radius: 5px;
}
.item .item-block > div:nth-child(1) {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.item .item-block > div:nth-child(1) > div:nth-child(1) img {
  width: 35px;
  height: 35px;
}
.item .item-block > div:nth-child(1) > div:nth-child(2) {
  margin-top: 5px;
  font-size: 16px;
  font-weight: bold;
  color: #4c83e3;
}
.item .item-block > div:nth-child(2) {
  padding: 20px;
  border-left: solid 1px #d3d3d3;
  margin-left: 20px;
}
.item .item-block > div:nth-child(2) > div:nth-child(1) {
  color: #4c83e3;
  margin-top: 5px;
  font-size: 18px;
}
.item .item-block > div:nth-child(2) > div:nth-child(2) {
  line-height: 2.5;
}
.item .item-block > div:nth-child(2) > div:nth-child(3) {
  color: #4c83e3;
}

.warning-tips-box {
  padding: 10px 40px;
  box-sizing: border-box;
  border: 1px solid rgba(247, 141, 76, 0.5);
  position: relative;
  background-color: #fff9f6;
  margin-bottom: 20px;
  padding-left: 28px;
  font-size: 14px;
}
.warning-tips-box .title {
  left: 28px;
  font-size: 14px;
  color: #333333;
  font-weight: bold;
  margin-bottom: 5px;
}
.warning-tips-box .title i {
  color:#E6A23C;
}
.warning-tips-box .result .red {
  color: #e2202c;
}
.warning-tips-box .result .big {
  font-weight: bold;
}
.infoicon {
  margin-right: 4px;
  display: inline-block;
  width: 14px;
  height: 13px;
  background: url("../assets/img/infoicon.png") no-repeat center center/100%
    100%;
}
</style>



// WEBPACK FOOTER //
// DownloadList.vue?f94c0762